import { CallAPI } from "../../apiManager/ApiCall";
import {
  related3dAdminLinkURL,
  related3dAdminListURL,
  related3dSuggestionsURL,
} from "../../apiManager/APIConfig";

const queryString = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v) !== "") {
      q.append(k, String(v));
    }
  });
  const s = q.toString();
  return s ? `?${s}` : "";
};

export const GetRelated3DAdminListCall = async (params = {}) =>
  CallAPI({
    url: `${related3dAdminListURL}${queryString(params)}`,
    method: "GET",
  });

export const UpsertRelated3DLinkCall = async (body) =>
  CallAPI({
    url: related3dAdminLinkURL,
    method: "POST",
    body,
  });

export const DeleteRelated3DLinkCall = async (id) =>
  CallAPI({
    url: `${related3dAdminLinkURL}/${id}`,
    method: "DELETE",
  });

// App-facing separate endpoint (for later mobile use)
export const GetRelated3DSuggestionsCall = async (params = {}) =>
  CallAPI({
    url: `${related3dSuggestionsURL}${queryString(params)}`,
    method: "GET",
  });

